module.exports = __webpack_public_path__ + "static/img/cogwheels.9ae018b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cogwheels.png
// module id = ZHGo
// module chunks = 0